/**
 * Safely parse a JSON string, returning a fallback value if parsing fails.
 * Handles cases where backend returns empty strings, non-JSON strings,
 * or error messages instead of valid JSON.
 */
const safeJsonParse = <T>(value: unknown, fallback: T): T => {
  if (typeof value !== "string" || value === "") return fallback

  try {
    return JSON.parse(value) as T
  } catch {
    console.warn(`Failed to parse JSON: ${value.substring(0, 200)}`)
    return fallback
  }
}

export default safeJsonParse
